import React from 'react';
import Button from '../Components/Buttons';
import {CustomInput} from "./CustomFormElements";

function ConnectionHeadersAttributes({
  headerAttributes,
  setHeaderAttributes,
  canEdit,
}) {
  const addHeader = () => {
    setHeaderAttributes([
      ...(headerAttributes || []),
      {
        header_name: '',
        header_value: '',
      },
    ]);
  };

  const removeHeader = (index) => {
    const next = (headerAttributes || []).filter((_, i) => i !== index);
    setHeaderAttributes(next);
  };

  const updateHeader = (index, field, value) => {
    const next = [...(headerAttributes || [])];
    next[index] = { ...next[index], [field]: value };
    setHeaderAttributes(next);
  };

  const isDisabled = !canEdit;

  return (
    <div className='int-col-3 p-2 border-yes radius-yes full-width-on-sml-scr'>
      <h4 className='h4-title'>Header Attributes</h4>
      <div className='small-font mb-2'>
        Define headers (key/value) that will be sent with requests
      </div>

      {(headerAttributes || []).map((h, index) => (
        <div key={index} className='attribute-row mb-2 p-2 border-yes radius-yes'>
          <div className='input-block d-flex flex-row justify-between'>
            <div className='input-description'>
              <div className='input-title'>Header Name</div>
              <div className='small-font'>e.g. Authorization, X-API-Key</div>
            </div>
            <div className='align-wrapper d-flex align-center gap'>
              <CustomInput
                id={`header-name-${index}`}
                label="Header Name"
                placeholder="Enter header name"
                type="text"
                value={h.header_name || ''}
                onChange={(id, value) => updateHeader(index, 'header_name', value)}
                disabled={isDisabled}
              />
              {!isDisabled && (
                <Button variant='danger' size='small' onClick={() => removeHeader(index)}>
                  <i className="fa-solid fa-trash"></i>
                </Button>
              )}
            </div>
          </div>

          <div className='input-block d-flex flex-row justify-between'>
            <div className='input-description'>
              <div className='input-title'>Header Value</div>
              <div className='small-font'>Value to send (optional)</div>
            </div>
            <div className='align-wrapper d-flex align-center'>
              <CustomInput
                id={`header-value-${index}`}
                label="Header Value"
                placeholder="Enter header value"
                type="text"
                value={h.header_value || ''}
                onChange={(id, value) => updateHeader(index, 'header_value', value)}
                disabled={isDisabled}
              />
            </div>
          </div>
        </div>
      ))}

      {!isDisabled && (
        <Button variant='secondary' size='medium' onClick={addHeader}>
          <i className="fa-solid fa-plus"></i> Add Header
        </Button>
      )}
    </div>
  );
}

export default ConnectionHeadersAttributes;
